import { ValidationErrors, FormControl } from '@angular/forms';
 
export function israelIDValidator(control: FormControl): ValidationErrors | null {
    let value: string = control.value;
   let israelid: boolean = false;
  debugger
    if (value) {
        if (value.length > 9 ) {//|| value.length < 5
            return { israelid: true };
        }

        if (value.length < 9) {
            while (value.length < 9) value = '0' + value;
        }

        let sum = 0,
            i = 0,
            x: string | number = 0;

        for (i = 0; i < 8; i++) {
            x = ((i % 2) + 1) * Number(value[i]);

            if (x > 9) {
                x = x.toString();
                x = Number(x[0]) + Number(x[1]);
            }

            sum += x;
        }

        if ((sum + Number(value[8])) % 10 !== 0 || value === '000000000') {
            return { israelid: true };
        }

        return null;
    }
}
